import { useDispatch } from "react-redux";

import { handBookActions } from "../../model/slice";
import { applyEditingHandbook, cancelEditingHandbook, localDeleteCheckedHandbooks } from "../../model/thunks";
import HandBookEditButtonBase from "./HandBookEditButtonBase";
import { useTypedSelector } from "app/store/typedUseSelector";

const HandBookEditButton = () => {
  const dispatch = useDispatch();
  const editings = useTypedSelector((state) => state.handBookReducer.editings);
  const isEditing = editings.isEditing;

  const enableEditing = () => {
    dispatch(handBookActions.setEditing(true));
  };
  const cancelEditing = () => {
    dispatch(cancelEditingHandbook());
  };
  const applyEditing = () => {
    dispatch(applyEditingHandbook());
  };
  const deleteChecked = () => {
    dispatch(localDeleteCheckedHandbooks());
  };

  return (
    <HandBookEditButtonBase
      editings={editings}
      isEditing={isEditing}
      enableEditing={enableEditing}
      cancelEditing={cancelEditing}
      applyEditing={applyEditing}
      deleteChecked={deleteChecked}
      modalTitle="Редактирование справочника"
    />
  );
};

export default HandBookEditButton;
